export const APP_MODULES = [
  { id: "dashboard", label: "Dashboard", href: "/dashboard" },
  { id: "sales", label: "Sales", href: "/dashboard/sales" },
  { id: "stock", label: "Stock", href: "/dashboard/stock" },
  { id: "purchasing", label: "Purchasing", href: "/dashboard/purchasing" },
  { id: "reports", label: "Reports", href: "/dashboard/reports" },
  { id: "admin", label: "Admin", href: "/dashboard/admin" },
  { id: "restaurant", label: "Restaurant", href: "/dashboard/pos/tables" },
] as const

export type AppModule = (typeof APP_MODULES)[number]["id"]

export type SidebarFeatures = {
  salesSidebar?: boolean
  purchaseSidebar?: boolean
  touchPos?: boolean
  posRegister?: boolean
}

export function hasModule(modules: string[] | undefined, module: AppModule) {
  return modules?.includes(module) ?? false
}

export function isSalesSidebarEnabled(features?: SidebarFeatures) {
  return features?.salesSidebar !== false
}

export function isPurchaseSidebarEnabled(features?: SidebarFeatures) {
  return features?.purchaseSidebar !== false
}

export function firstAllowedRoute(modules: string[] | undefined, features?: SidebarFeatures) {
  for (const item of APP_MODULES) {
    if (!hasModule(modules, item.id)) continue
    if (item.id === "sales") {
      if (isSalesSidebarEnabled(features)) return item.href
      if (features?.posRegister !== false) return "/dashboard/pos/register"
      if (features?.touchPos === true) return "/dashboard/pos/touch"
      continue
    }
    if (item.id === "purchasing" && !isPurchaseSidebarEnabled(features)) continue
    return item.href
  }
  return "/dashboard"
}
